var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFreeVieweetLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 26,
    viewBox: "0 0 45 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.301758H10.21L18.71 13.0618V25.8118H17.01L0 0.301758Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1322 13.4537C33.8952 12.9438 34.7923 12.6717 35.71 12.6717C36.3197 12.6704 36.9237 12.7895 37.4872 13.0222C38.0507 13.2549 38.5628 13.5967 38.9939 14.0278C39.425 14.4589 39.7668 14.971 39.9995 15.5345C40.2322 16.098 40.3513 16.702 40.35 17.3117C40.35 18.2294 40.0779 19.1265 39.568 19.8896C39.0582 20.6526 38.3335 21.2473 37.4856 21.5985C36.6378 21.9497 35.7049 22.0416 34.8048 21.8625C33.9047 21.6835 33.0779 21.2416 32.429 20.5927C31.7801 19.9438 31.3382 19.117 31.1592 18.2169C30.9801 17.3168 31.072 16.3839 31.4232 15.5361C31.7744 14.6882 32.3691 13.9635 33.1322 13.4537Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.21 25.8117L18.71 25.8118V13.0618L18.71 0.301758H44.22V8.80176H27.21V25.8117Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeVieweetLogo);
export default __webpack_public_path__ + "static/media/free-vieweet-logo.cc2a8effa0c9d1843f150620b4824f25.svg";
export { ForwardRef as ReactComponent };